<style lang="scss" src="./PageSpace.scss"></style>
<script lang="ts" src="./PageSpace.ts"></script>

<template>
  <div :class="props.parentClass">
    <div :class="props.childClass" />
  </div>
</template>